import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { NotificationManager } from "react-notifications";
import { parseQueryString } from "lib/general-helper";
import { GET_USER_SETTINGS } from "api/graphql/queries";

import "react-notifications/lib/notifications.css";

const PerformanceAnalysisFooter = (props) => {
  const history = useHistory();
  const location = useLocation();

  const { loading, error, data } = useQuery(GET_USER_SETTINGS, {});

  const copyToClipboard = () => {
    if (navigator && navigator.clipboard) {
      const { port, protocol, hostname, pathname } = window.location;

      const { regionId, summonerName } = data.getSettings.lolSettings.summoners[0];
      const sharedLink = `${protocol}//${hostname}${
        port ? `:${port}` : ""
      }${pathname}?region=${regionId}&summonerName=${summonerName}&sharing=true`;

      navigator.clipboard.writeText(sharedLink).then(
        () => {
          NotificationManager.success("Link copied to clipboard");
        },
        (err) => {
          NotificationManager.error("Could not copy to clipboard");
        },
      );
    }
  };

  const renderShare = () => {
    const searchParams = parseQueryString(location.search.substring(1));
    if (searchParams.sharing !== "true") {
      return (
        <React.Fragment>
          <button className="footer-cta" onClick={copyToClipboard}>
            <img src="https://static.bigbrain.gg/assets/lol/performance_analysis/icons/clipboard.svg" />
            <span>SHARE</span>
          </button>
          <div className="large-text">SHARE YOUR YEAR IN REVIEW</div>
          <div className="small-text">Same time and place next year sound good? (See you in 2021.)</div>
        </React.Fragment>
      );
    } else {
      return <React.Fragment />;
    }
  };
  return (
    <div className="performance-analysis_footer">
      <img className="review-icon" src="https://static.bigbrain.gg/assets/lol/performance_analysis/images/L20_gold.svg" />
      {renderShare()}
    </div>
  );
};

export default PerformanceAnalysisFooter;
